import { render, staticRenderFns } from "./SubjectUser.vue?vue&type=template&id=1e107742&scoped=true&"
import script from "./SubjectUser.ts?vue&type=script&lang=ts&"
export * from "./SubjectUser.ts?vue&type=script&lang=ts&"
import style0 from "./subject-user.scss?vue&type=style&index=0&id=1e107742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e107742",
  null
  
)

export default component.exports